import { Injectable, signal } from '@angular/core';

export interface ConfirmRequest {
  title: string;
  message: string;
  confirmLabel: string;
  /** Colora l'azione come distruttiva (eliminazioni). */
  danger: boolean;
}

interface PendingConfirm extends ConfirmRequest {
  resolve: (confirmed: boolean) => void;
}

/**
 * Conferme per le azioni irreversibili.
 *
 * Deliberatamente non usa `window.confirm`: nella documentazione di questo ambiente i
 * dialoghi nativi bloccano l'automazione del browser, e comunque non sono stilabili.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private readonly current = signal<PendingConfirm | null>(null);

  readonly pending = this.current.asReadonly();

  ask(
    request: Partial<ConfirmRequest> & Pick<ConfirmRequest, 'title' | 'message'>,
  ): Promise<boolean> {
    // Una conferma alla volta: se ne arriva un'altra la precedente si intende annullata.
    this.current()?.resolve(false);

    return new Promise<boolean>((resolve) => {
      this.current.set({
        confirmLabel: 'Conferma',
        danger: false,
        ...request,
        resolve,
      });
    });
  }

  answer(confirmed: boolean): void {
    const pending = this.current();
    if (pending === null) {
      return;
    }
    this.current.set(null);
    pending.resolve(confirmed);
  }
}
